import {
  DATOS_FIJOS_AUTORIZACION,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
} from "./AutorizacionConstant";

export const getNombreProcedimiento = (procedimiento) => {
  const { nombreCobertura, cobertura } = procedimiento;
  if (nombreCobertura === "Totales") {
    return <span>{nombreCobertura}</span>;
  }
  return nombreCobertura ? `(${cobertura}) ${nombreCobertura}` : cobertura;
};

export const getTipoServicioTipoCobertura = (tipoServicio) => {
  return Number(tipoServicio + DATOS_FIJOS_AUTORIZACION.CODIGO_TIPO_COBERTURA);
};

export const getObjetoAutorizacion = (numeroAutorizacion) => {
  const fragmentosAutorizacion = numeroAutorizacion?.split("-");

  if (fragmentosAutorizacion?.length === 4) {
    return {
      anio: fragmentosAutorizacion[0],
      compania: fragmentosAutorizacion[1],
      ramo: fragmentosAutorizacion[2],
      secuencial: fragmentosAutorizacion[3],
    };
  }

  return null;
};

export const parseStringAutorizacion = (numeroAutorizacion) => {
  if (typeof numeroAutorizacion !== "string" || numeroAutorizacion.length < 8) {
    return null;
  }

  return {
    ano: numeroAutorizacion.substring(0, 4),
    compania: numeroAutorizacion.substring(4, 6),
    ramo: numeroAutorizacion.substring(6, 8),
    secuencial: numeroAutorizacion.substring(8),
  };
};

export const desfragmentarCodigoAutorizacion = (codigo) => {
  // Verificar si el código tiene el formato correcto, ejemplo P94-5017941 o H95-5017935
  const regex = /^[PH]\d+-\d+$/;
  if (!regex.test(codigo)) {
    return null;
  }

  // Extraer los valores necesarios del código
  const compania = codigo[0] === "P" ? 96 : 30;
  const ramo = parseInt(codigo.substring(1, codigo.indexOf("-")), 10);
  const secuencial = parseInt(codigo.substring(codigo.indexOf("-") + 1), 10);

  return {
    compania,
    ramo,
    secuencial,
  };
};

export const fragmentarCodigoAutorizacion = (compania, ramo, secuencial) => {
  const primerCaracter = compania === 30 ? "H" : "P";

  const numeroAutorizacion = `${primerCaracter}${ramo}-${secuencial}`;

  return numeroAutorizacion;
};

export const getStandVirtualFullUrl = (token) => {
  return `${process.env.REACT_APP_STAND_VIRTUAL_URL}?tid=${token}&compania=${process.env.REACT_APP_COMPANY}`;
};

export const homologarCodigoTipoServicio = (codigoTipoServicio) => {
  if (
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.DIALISIS ||
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.QUIMIOTERAPIA ||
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.RADIOTERAPIA
  ) {
    return CODIGO_TIPO_SERVICIO_AUTORIZACION.ALTO_COSTO;
  }

  return codigoTipoServicio;
};

export const agruparObjetoAutorizacion = (autList) => {
  if (!autList || autList.length === 0) return null;
  if (autList.length === 1) return autList[0];

  return autList.reduce(
    (acumulado, autorizacion, index) => {
      if (index === 0) return autorizacion;

      acumulado.montoPagado += Number(autorizacion.montoPagado);
      acumulado.montoReclamado += Number(autorizacion.montoReclamado);
      acumulado.nombreCobertura += `, ${autorizacion.nombreCobertura}`;
      acumulado.cobertura += `, ${autorizacion.cobertura}`;

      return acumulado;
    },
    { ...autList[0] }
  );
};

export const getMontoTotalReclamado = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoReclamado,
    0
  );
};

export const getMontoAutorizadoPrimera = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) =>
      acumulador + procedimiento.montoAutorizacionPrimera,
    0
  );
};

export const getMontoAutorizadoHumano = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) =>
      acumulador + procedimiento.montoAutorizacionHumano,
    0
  );
};

export const getMontoAutorizadoTotal = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoAutorizado,
    0
  );
};

/**
 * Obtiene el primer valor válido (no null, no undefined) de una lista de propiedades
 * @param {Object} objeto - El objeto del cual extraer los valores
 * @param {Array<string>} propiedades - Array de nombres de propiedades en orden de prioridad
 * @param {*} valorPorDefecto - Valor a retornar si ninguna propiedad es válida
 * @returns {*} El primer valor válido encontrado o el valor por defecto
 */
const obtenerPrimerValorValido = (objeto, propiedades, valorPorDefecto = 0) => {
  for (const propiedad of propiedades) {
    const valor = objeto[propiedad];
    if (valor !== undefined && valor !== null) {
      return valor;
    }
  }
  return valorPorDefecto;
};

export const normalizarMontoDiferencia = (procedimientos) => {
  return procedimientos?.map((procedimiento) => ({
    ...procedimiento,
    montoDiferencia: obtenerPrimerValorValido(
      procedimiento,
      ['montoAfiliado', 'montoDiferencia', 'montoAsegurado'],
      0
    ),
  }));
};

export const getMontoDiferencia = (procedimientos) => {
  const procedimientosNormalizados = normalizarMontoDiferencia(procedimientos);
  return procedimientosNormalizados?.reduce(
    (acumulador, procedimiento) =>
      acumulador + (procedimiento.montoDiferencia || 0),
    0
  );
};
